export default __webpack_public_path__ + "static/media/IMG-20250105-WA0028.90743282.jpg";